import { AmortizationTypes } from "services/Amortization/types/amortizationModels";

export class QueryAmortizationCreateModel {
    productId!: string;
    legalPerson?: boolean;
    personId?: string;
    registrationNumber?: string;
    amortization: AmortizationTypes = {} as AmortizationTypes;
}
